import { render, staticRenderFns } from "./editRoleSubmit.vue?vue&type=template&id=198fadf6&scoped=true&"
import script from "./editRoleSubmit.vue?vue&type=script&lang=js&"
export * from "./editRoleSubmit.vue?vue&type=script&lang=js&"
import style0 from "./editRoleSubmit.vue?vue&type=style&index=0&id=198fadf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198fadf6",
  null
  
)

export default component.exports